module.exports = __webpack_public_path__ + "6232c913105e73920dcc7a3eb30b0b36.png";